var generateStyle = function generateStyle(componentTheme) {
  return {
    section: {
      paddingBottom: componentTheme.sectionPadding
    },
    optionalLabel: {
      color: componentTheme.optionalLabelColor,
      fontSize: componentTheme.optionalLabelFontSize,
      marginLeft: componentTheme.urlLabelMargin
    }
  };
};
export default generateStyle;